import api from './api';

const BASE_URL = '/admin/expenses';
const PERIODS_URL = '/admin/accounting-periods';

const expensesService = {
  // Expense Management
  getExpenses: async (params) => {
    const response = await api.get(`${BASE_URL}/`, { params });
    return response.data;
  },

  getExpense: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}/`);
    return response.data;
  },

  createExpense: async (data) => {
    const response = await api.post(`${BASE_URL}/`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  updateExpense: async (id, data) => {
    const response = await api.patch(`${BASE_URL}/${id}/`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  deleteExpense: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}/`);
    return response.data;
  },

  approveExpense: async (id) => {
    const response = await api.post(`${BASE_URL}/${id}/approve/`);
    return response.data;
  },

  rejectExpense: async (id, reason) => {
    const response = await api.post(`${BASE_URL}/${id}/reject/`, { reason });
    return response.data;
  },

  // Accounting Periods
  getAccountingPeriods: async (params) => {
    const response = await api.get(`${PERIODS_URL}/`, { params });
    return response.data;
  },

  lockPeriod: async (id) => {
    const response = await api.post(`${PERIODS_URL}/${id}/lock/`);
    return response.data;
  },

  unlockPeriod: async (id) => {
    const response = await api.post(`${PERIODS_URL}/${id}/unlock/`);
    return response.data;
  },

  // Exports
  exportCsv: async (params) => {
    const response = await api.get(`${BASE_URL}/export_csv/`, {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  exportExcel: async (params) => {
    const response = await api.get(`${BASE_URL}/export_excel/`, {
      params,
      responseType: 'blob',
    });
    return response.data;
  },
};

export default expensesService;
